import script from "./SearchInputs.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchInputs.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'directives', {ClosePopup});
